import { createSelector } from '@ngrx/store';

import { PERSONAL_MEDIA_ITEMS_FEATURE_KEY } from '../constants';
import { selectPersonalMediaState } from '../main-selector';

import { PersonalMediaItemsState } from './personal-media-items.reducer';

export const selectPersonalMediaItemsState = createSelector(
  selectPersonalMediaState,
  (state) => state[PERSONAL_MEDIA_ITEMS_FEATURE_KEY],
);

export const selectAllPersonalMediaItems = createSelector(
  selectPersonalMediaItemsState,
  (state: PersonalMediaItemsState) => state.mediaItems,
);

/**
 * Selector to get all the lookBooks
 */
export const selectPersonalMediaItemsLoading = createSelector(
  selectPersonalMediaItemsState,
  (state: PersonalMediaItemsState) => state.loading,
);

/**
 * Selector to get all the lookBooks
 */
export const selectPersonalMediaItemsError = createSelector(
  selectPersonalMediaItemsState,
  (state: PersonalMediaItemsState) => state.error,
);
